import { Button, Col, DatePicker,  Row, TimePicker } from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import { useDispatch, useSelector } from "react-redux";
import { showLoading, hideLoading } from "../redux/alertSlice";
import { toast } from "react-hot-toast";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
// import moment from "moment";
// const url = "http://localhost:8000";
const url = process.env.REACT_APP_BACKEND_URL;
function BookAppointment() {
  const [isAvailable, setIsAvailable] = useState(false);
  const navigate = useNavigate();
  const [date, setDate] = useState();
  const [time, setTime] = useState();
  const { user } = useSelector((state) => state.user);
  const [doctor, setDoctor] = useState(null);
  const params = useParams();
  const dispatch = useDispatch();

  const getDoctorData = async () => {
    try {
      dispatch(showLoading());
      const response = await axios.post(
        `${url}/api/doctor/get-doctor-info-by-id`,
        {
          doctorId: params.id,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(hideLoading());
      if (response.data.success) {
        setDoctor(response.data.data);
      }
    } catch (error) {
      console.log(error);
      dispatch(hideLoading());
    }
  };
  const checkAvailability = async () => {
    try {
      dispatch(showLoading());
      let currDate = new Date(date);
      const fDate = currDate.getDate() + "-" + (currDate.getMonth() + 1) + "-" + currDate.getFullYear();
      let sDate = new Date(time.$d);
      let sh = "";
      let sm = "";
      if (sDate.getHours() < 10) {
        sh = "0" + sDate.getHours();
      } else {
        sh = sDate.getHours();
      }
      if (sDate.getMinutes() < 10) {
        sm = "0" + sDate.getMinutes();
      } else {
        sm = sDate.getMinutes();
      }
      const fTime = sh + ":" + sm;
      const response = await axios.post(
        `${url}/api/user/check-booking-availability`,
        {
          doctorId: params.id,
          date: fDate,
          time: fTime,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        toast.success(response.data.message);
        setIsAvailable(true);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Error booking appointment");
      dispatch(hideLoading());
    }
  };
  const bookNow = async () => {
    setIsAvailable(false);
    try {
      dispatch(showLoading());
      let currDate = new Date(date);
      const fDate = currDate.getDate() + "-" + (currDate.getMonth() + 1) + "-" + currDate.getFullYear();
      let sDate = new Date(time.$d);
      let sh = "";
      let sm = "";
      if (sDate.getHours() < 10) {
        sh = "0" + sDate.getHours();
      } else {
        sh = sDate.getHours();
      }
      if (sDate.getMinutes() < 10) {
        sm = "0" + sDate.getMinutes();
      } else {
        sm = sDate.getMinutes();
      }
      const fTime = sh + ":" + sm;
      const response = await axios.post(
        `${url}/api/user/book-appointment`,
        {
          doctorId: params.id,
          userId: user._id,
          doctorInfo: doctor,
          userInfo: user,
          date: fDate,
          time: fTime,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      dispatch(hideLoading());
      if (response.data.success) {
        
        toast.success(response.data.message);
        navigate('/appointments')
      }
    } catch (error) {
      toast.error("Error booking appointment");
      dispatch(hideLoading());
    }
  };

  useEffect(() => {
    getDoctorData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Layout>
      {doctor && (
        <div>
          <h2 className="page-title">
            {doctor.firstName} {doctor.lastName}
          </h2>
          <hr />
          <Row gutter={20} className="booking-card" align="middle">
            <Col span={8} sm={24} xs={24} lg={8}>
              <h1 className="normal-text">
                <b>Timings :</b> {doctor.timings[0]} - {doctor.timings[1]}
              </h1>
              <p>
                <b>Phone Number : </b>
                {doctor.phoneNumber}
              </p>
              <p>
                <b>Address : </b>
                {doctor.address}
              </p>
              <p>
                <b>Fee per Visit : </b>
                {doctor.feePerConsultation}
              </p>
              <p>
                <b>Website : </b>
                {doctor.website}
              </p>
              <div className="date-picker">
                <DatePicker
                  format="DD-MM-YYYY"
                  onChange={(value) => {
                    setDate(value);
                    setIsAvailable(false);
                  }}
                />
                <TimePicker
                  format="HH:mm"
                  className="mt-3"
                  onChange={(value) => {
                    setIsAvailable(false);
                    setTime(value);
                  }}
                />
              {!isAvailable &&   <Button
                  className="primary-button mt-3 full-width-button"
                  onClick={checkAvailability}
                >
                  Check Availability
                </Button>}

                {isAvailable && (
                  <Button
                    className="primary-button mt-3 full-width-button"
                    onClick={bookNow}
                  >
                    Book Now
                  </Button>
                )}
              </div>
            </Col>
            <Col span={8} sm={24} xs={24} lg={8}>
              <img
                src="https://thumbs.dreamstime.com/b/finger-press-book-now-button-booking-reservation-icon-online-149789867.jpg"
                alt="Book Now"
                width="100%"
                height='300'
              />
            </Col>
          </Row>
        </div>
      )}
    </Layout>
  );
}

export default BookAppointment;